import { UntypedFormControl } from '@angular/forms';

export class ExtendedInformationModel {
  msr: UntypedFormControl;
  msd: UntypedFormControl;
  cto: UntypedFormControl;
  hsb: UntypedFormControl;
  sta: UntypedFormControl;
  plc: UntypedFormControl;
  rst: UntypedFormControl;
  rpc: UntypedFormControl;
  rcs: UntypedFormControl;
  rct: UntypedFormControl;
  ctp: UntypedFormControl;
  ctq: UntypedFormControl;
  ctr: UntypedFormControl;
  cts: UntypedFormControl;
  hac: UntypedFormControl;
  hts: UntypedFormControl;
  hz1: UntypedFormControl;
  naf: UntypedFormControl;
  tmc: UntypedFormControl;
  cpn: UntypedFormControl;
  ccl: UntypedFormControl;
  cgr: UntypedFormControl;
  cxp: UntypedFormControl;
  ltm: UntypedFormControl;
  rpq: UntypedFormControl;
  whs: UntypedFormControl;
  vmi: UntypedFormControl;
  ecn: UntypedFormControl;
  gct: UntypedFormControl;
  gpv: UntypedFormControl;
}
